import { useQuery } from '@tanstack/react-query';
import { projectListQueries } from '../queries';
import type { ManagerKind } from '../types/ProjectList';

/**
 * Hook de busca de gestores de um tipo, no formato que o `SearchCombobox`
 * espera (`useSearch(text) => { data, isFetching }`). Devolve uma função para
 * cada combo; o chamador a memoiza (um `useQuery` por render, só o texto muda).
 */
export function createManagerSearch(kind: ManagerKind) {
  return (search: string) => useQuery(projectListQueries.managers(kind, search));
}
